import { TissueTestAPI } from '@/api';
import kirill_format from './kirill-format.data'

// TODO: Разобраться с разными видами наборов нутриентов ебанутая хуита

const default_form = {
  name: '',
  fieldId: 0,
  farmId: 0,
  cropId: 0,
  variety: null,
  tissue: null,
  samplingTime: null,
  tissueTestId: 0,
  data: [],
  crops: [],
};

export default {
  namespaced: true,
  state: {

    form: JSON.parse(JSON.stringify(default_form)),
    test: {},

    is_creating: false,

  },
  mutations: {
    setForm(state, form) {
      state.form = form;
    },
    setTest(state, test) {
      state.test = test;
    },
    clearForm(state) {
      state.form = JSON.parse(JSON.stringify(default_form));
    },
    setData(state, data) {
      state.form.data = data;
    },
    setCrops(state, data) {
      state.crops = data;
    },
    setCreateMode(state, mode) {
      state.is_creating = mode;
    }
  },
  actions: {

    getTissueCrops({commit, state}) {
      return TissueTestAPI.getCrops().then(res => {
        commit('setCrops', res.data.data);
      })
    },

    createTest({ commit, dispatch, state, getters, rootGetters }) {
      const form = { ...state.form };
      form.data = JSON.stringify(getters.adapterNormalToKirillFormat());
      form.dataInterpretations = JSON.stringify(getters.getKirillInterpretations());
      return TissueTestAPI.create(form).then(res => {
        if(rootGetters['tests/sidebar/filters'].type == 'tissue-anal') {
          dispatch('tests/sidebar/updateData', null, { root: true });
        }
        return res.data.data;
      });
    },

    save({ commit, dispatch, state, getters, rootGetters }) {
      const form = { ...state.form };
      form.data = JSON.stringify(getters.adapterNormalToKirillFormat());
      form.dataInterpretations = JSON.stringify(getters.getKirillInterpretations());
      return TissueTestAPI.update(form.id, form).then(res => {
        if(rootGetters['tests/sidebar/filters'].type == 'tissue-anal') {
          dispatch('tests/sidebar/updateData', null, { root: true });
        }
        return res.data.data;
      });
    },

    deleteTest({ commit, dispatch, state, getters, rootGetters }) {
      return TissueTestAPI.delete(state.form.id).then(res => {
        if(rootGetters['tests/sidebar/filters'].type == 'tissue-anal') {
          dispatch('tests/sidebar/updateData', null, { root: true });
        }
      });
    },

    getSingle({ commit, dispatch, state, getters }, test) {

      return TissueTestAPI.getAnalysis(test).then(res => {
        // TODO: убрать нахуй и что бы на бэке это все парсило и не присылало в одну data
        const data = res.data.data;
        data.data = JSON.parse(data.data);
        data.data = getters.adapterKirillToNormalFormat(data.data);
        data.test.data = JSON.parse(data.test.data);

        // TODO убрать после того как кирилл уменьшит колво данных для теста
        data.tissue = data.test.tissue;
        data.variety = data.test.variety;
        data.samplingTime = data.test.samplingTime;
        commit('setTest', data.test);
        delete data.test;

        commit('setForm', data);
        dispatch('parseDataToLatestVersion');
      });
    },

    /**
     *
     * Это надо что бы если вдруг обновится список нутриентов
     * оно должно добавить недостающие нутриенты в нынешней дате
     */
    parseDataToLatestVersion() {
      // TODO: )))
    },

    initDefaultData({ commit, rootGetters, getters }) {
      commit('setData', getters.getNormalFormat());
    },
  },
  getters: {
    form(state) {
      return state.form
    },

    /**
     * Сложная хуета для парса двух форматов , когда у кирилла будет больше времени заменим
     * что бы норм было
     *
     * объясняю - кирилл попросил передавать данные в другом формате ,
     * но я уже успел по своему сделать
     * На первое время пойдет , но он по сути не правильный , я не хочу тут
     * устраивать Алазара номер два
     *
     * По этому и сделал функции для парса моего формата в его и обратно
     */
    adapterNormalToKirillFormat: state => () => {
      let obj = {};
      for (const key in kirill_format) {
        try {
          obj[key] = state.form.data.find(n => n.key == kirill_format[key]).value;
        } catch (error) {
          console.error('Some of nutrients are missing in your data, compare kirill-format.data and global nutrients');
        }
      }
      return obj;
    },

    /**
     * Сложная хуета для парса двух форматов , когда у кирилла будет больше времени заменим
     * что бы норм было
     */
    adapterKirillToNormalFormat: (state, getters) => data => {
      return getters.getNormalFormat()
        .map(n => {
          for (const key in kirill_format) {
            if(kirill_format[key] == n.key && data[key]) {
              n.value = data[key];
            }
          }
          return n;
        });

    },

    /**
     * Вот это формат в котором должно отсылаться на сервер (Normal)
     */
    getNormalFormat: (state, getters, rootState, rootGetters) => () => {
      return [
        ...rootGetters['nutrients/nForms'].map(n => {
          return {
            key: n.key,
            n_form: true,
            value: null,
          }
        }).filter(n => ['NNO3', 'NNH4', 'NNH2'].indexOf(n.key) == -1),
        ...rootGetters['nutrients/data'].map(n => {
          return {
            key: n.key,
            micro: true,
            value: null,
          }
        }).filter(n => ['NNO3', 'NNH4', 'NNH2'].indexOf(n.key) == -1),
      ]
    },

    isCreating(state) {
      return state.is_creating
    },

    interpretations(state) {
      try {
        return state.test.data.TissueAnalysis.Element.map(n => {
          return {
            type: n['-Type'],
            from_adeq: parseFloat(n['ExtractionMethod']['-FromAdequate']),
            from_exces: parseFloat(n['ExtractionMethod']['-FromExcessive']),
            from_high: parseFloat(n['ExtractionMethod']['-FromHigh']),
            from_low: parseFloat(n['ExtractionMethod']['-FromLow']),
            to_adeq: parseFloat(n['ExtractionMethod']['-ToAdequate']),
            to_high: parseFloat(n['ExtractionMethod']['-ToHigh']),
            to_low: parseFloat(n['ExtractionMethod']['-ToLow']),
          }
        });
      } catch (error) {
        return [];
      }
    },

    getKirillInterpretations: (state, getters) => () => {
      const ints = getters.interpretations;
      const obj = {};

      for (const i in ints) {
        const row = getters.getDataRowByNutrient(ints[i].type);
        if(!row) {
          continue;
        }
        console.log(row.value, getters.getWarningLevel(row.value, ints[i].type));

        obj[ints[i].type + '_Interpretation'] = getters.renderWarningLevel(
          getters.getWarningLevel(row.value, ints[i].type)
        );
      }

      return obj;
    },

    getInterpretationByNutrient: (state, getters) => nut => {
      if (nut == 'Cl' && !getters.interpretations.find(n => n.type === nut)) nut = 'CL'
      return getters.interpretations.find(n => n.type === nut)
    },

    getWarningLevel: (state, getters) => (val, nut) => {
      const lvls = getters['getInterpretationByNutrient'](nut);

      if(!lvls) {
        return null;
      }

      if(val == null || val == 0) {
        return null;
      }

      if(val >= lvls.from_low && val < lvls.to_low) {
        return 1;
      }
      else if(val >= lvls.from_adeq && val < lvls.to_adeq) {
        return 2;
      }
      else if(val >= lvls.from_high && val < lvls.to_high) {
        return 3;
      }
      else if(val >= lvls.from_exces) {
        return 4;
      }
      else {
        return null;
      }
    },

    renderWarningLevel: (state, getters) => (lvl) => {
      if(lvl === 1) {
        return 'Low';
      }
      else if(lvl === 2) {
        return 'Adequate';
      }
      else if(lvl === 3) {
        return 'High';
      }
      else if(lvl === 4) {
        return 'Excessive';
      }
      else {
        return null;
      }
    },

    test(state) {
      return state.test;
    },

    data(state) {
      return state.form.data;
    },

    getDataRowByNutrient: state => key => {
      return state.form.data.find(n => n.key == key);
    },

    crops(state) {
      return state.crops;
    },
  }
};
